export default "__VITE_ASSET__c24bf422__"